/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedemptionsReportTimeseries
 */
export interface RedemptionsReportTimeseries {
    /**
     * 
     * @type {Date}
     * @memberof RedemptionsReportTimeseries
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof RedemptionsReportTimeseries
     */
    unique: number;
    /**
     * 
     * @type {number}
     * @memberof RedemptionsReportTimeseries
     */
    repeat: number;
    /**
     * 
     * @type {number}
     * @memberof RedemptionsReportTimeseries
     */
    total: number;
}

/**
 * Check if a given object implements the RedemptionsReportTimeseries interface.
 */
export function instanceOfRedemptionsReportTimeseries(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "unique" in value;
    isInstance = isInstance && "repeat" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function RedemptionsReportTimeseriesFromJSON(json: any): RedemptionsReportTimeseries {
    return RedemptionsReportTimeseriesFromJSONTyped(json, false);
}

export function RedemptionsReportTimeseriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedemptionsReportTimeseries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'unique': json['unique'],
        'repeat': json['repeat'],
        'total': json['total'],
    };
}

export function RedemptionsReportTimeseriesToJSON(value?: RedemptionsReportTimeseries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date.toISOString()),
        'unique': value.unique,
        'repeat': value.repeat,
        'total': value.total,
    };
}

